var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * Copyright 2019, SumUp Ltd.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Image from '../../../Image';
import AspectRatio from '../../../AspectRatio';
import { ASPECT_RATIO } from '../../constants';
const backgroundStyles = css `
  background: var(--cui-bg-subtle);
`;
const StyledAspectRatio = styled(AspectRatio)(backgroundStyles);
const imageStyles = css `
  img {
    object-fit: cover;
  }
`;
const StyledImage = styled(Image)(imageStyles);
const SlideImage = (_a) => {
    var { src, alt, aspectRatio } = _a, props = __rest(_a, ["src", "alt", "aspectRatio"]);
    return (_jsx(StyledAspectRatio, Object.assign({ aspectRatio: aspectRatio }, { children: _jsx(StyledImage, Object.assign({ src: src, alt: alt }, props)) })));
};
SlideImage.propTypes = {
    /**
     * Specifies the source URL of an image.
     */
    src: PropTypes.string.isRequired,
    /**
     * Provides alternative information if a user cannot view the image,
     * e.g. because of slow connection, an error in the src attribute, or if the
     * user uses a screen reader.
     */
    alt: PropTypes.string.isRequired,
    /**
     * Image aspect ratio.
     */
    aspectRatio: PropTypes.number,
};
SlideImage.defaultProps = {
    aspectRatio: ASPECT_RATIO,
};
export default SlideImage;
